! function () {
    "use strict";
    var t, e = {
        4105: function (t, e, n) {
            n.d(e, {
                Q2: function () {
                    return o
                },
                gp: function () {
                    return s
                },
                hO: function () {
                    return r
                }
            });
            const o = function () {
                let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "json";
                return {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: `application/${t}`
                    }
                }
            },
                r = function () {
                    let t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                        e = window.innerWidth - document.body.offsetWidth;
                    const n = document.getElementById("nav-wrapper");
                    t ? (document.body.classList.add("no-scroll"), document.body.style.paddingRight = e + "px", n.style.paddingRight = e + "px") : (document.body.classList.remove("no-scroll"), document.body.style.paddingRight = "0px", n.style.paddingRight = "0px")
                };
            let a = () => { },
                c = t => {
                    "Escape" === t.key && (a(), window.removeEventListener("keydown", c))
                };
            const s = function () {
                let t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                    e = arguments.length > 1 ? arguments[1] : void 0;
                e && (a = e), t && window.addEventListener("keydown", c), t || window.removeEventListener("keydown", c)
            };
            document.querySelectorAll(".local-scroll").forEach((t => {
                t.addEventListener("click", (t => {
                    t.preventDefault(), t.stopPropagation();
                    const e = t.target.getAttribute("href");
                    (t => {
                        Math.easeInOutQuad = function (t, e, n, o) {
                            return (t /= o / 2) < 1 ? n / 2 * t * t + e : -n / 2 * (--t * (t - 2) - 1) + e
                        };
                        const e = document.getElementById("grid-archive-header"),
                            n = document.getElementById("nav-wrapper");
                        let o = 0;
                        e && (o = e.offsetHeight + 50), n && (navWrapperOffset = n.offsetHeight + 50);
                        const r = t.offsetTop - o - navWrapperOffset,
                            a = window.scrollY,
                            c = r - a;
                        let s = 0;
                        const i = () => {
                            s += 5;
                            const t = Math.easeInOutQuad(s, a, c, 200);
                            window.scrollTo(0, t), s < 200 && setTimeout(i, 5)
                        };
                        i()
                    })(document.querySelector(e))
                }))
            }))
        }
    },
        n = {};

    function o(t) {
        var r = n[t];
        if (void 0 !== r) return r.exports;
        var a = n[t] = {
            exports: {}
        };
        return e[t](a, a.exports, o), a.exports
    }
    o.d = function (t, e) {
        for (var n in e) o.o(e, n) && !o.o(t, n) && Object.defineProperty(t, n, {
            enumerable: !0,
            get: e[n]
        })
    }, o.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e)
    }, t = o(4105), (() => {
        const e = document.querySelectorAll('form:not(.js-product-form-main)[action="/cart/add"]'),
            n = document.getElementById("main-cart"),
            o = document.getElementById("overlay"),
            r = document.getElementById("mini-cart"),
            a = document.querySelector("body"),
            c = () => {
                r.classList.remove("open"), o.classList.remove("open"), a.style.removeProperty("overflow"), (0, t.hO)(!1)
            };
        e.length && e.forEach((e => e.addEventListener("submit", (a => {
            a.preventDefault(), a.stopPropagation(), a.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)') && (a.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)').textContent = `${cartStrings.addingToCart}`), a.target.querySelector('button[type="submit"]').classList.add("added"), a.target.querySelector('button[type="submit"] > span.cart-icon').style.display = "none", a.target.querySelector('button[type="submit"] > svg.loading-icon').style.display = "block";
            const s = (0, t.Q2)("javascript");
            s.headers["X-Requested-With"] = "XMLHttpRequest", delete s.headers["Content-Type"];
            let i = new FormData(e);
            for (var d of (s.body = i, i)) d[0], d[1];
            fetch(`${routes.cartAdd}`, s).then((t => t.json())).then((e => {
                e.status ? (a.target.querySelector('button[type="submit"] > span.cart-icon').style.display = "inline-flex", a.target.querySelector('button[type="submit"] > svg.loading-icon').style.display = "none", a.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)') && (a.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)').textContent = `${cartStrings.addToCart}`), a.target.querySelector(".product-converter__error").innerHTML = '<span class="icon loaded">error</span><p>' + e.description + "</p>") : (a.target.querySelector(".product-converter__error").innerHTML = "", n && n.classList.add("added"), window.cartStrings.miniCart ? (r && r.classList.add("open"), o && (o.classList.add("open", "overlay--all"), (0, t.hO)(!0), (0, t.gp)(!0, c))) : fetch("/cart.js").then((t => t.json())).then((t => {
                    0 === t.item_count ? document.querySelector(".header__icons--cart-open .cart-count").style.display = "none" : (document.querySelector(".header__icons--cart-open .cart-count").style.display = "flex", document.querySelector(".header__icons--cart-open .cart-count").textContent = t.item_count)
                })), a.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)') && (a.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)').textContent = `${cartStrings.addedToCart}`), a.target.querySelector('button[type="submit"]').classList.remove("added"), a.target.querySelector('button[type="submit"]').classList.add("successful"), a.target.querySelector('button[type="submit"] > span.cart-icon').style.display = "flex", a.target.querySelector('button[type="submit"] > svg.loading-icon').style.display = "none")
            })).catch((t => {
                console.error("Error:", t)
            }))
        }))))
    })()
}(); // This is just a sample script. Paste your real code (javascript or HTML) here.

if ('this_is' == /an_example/) {
    of_beautifier();
} else {
    var a = b ? (c % d) : e[f];
}